<template>
  <div>
	  <Header :sel='3' @changePhone="changePhone"/>
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	      <div class="banner">

  </div>
  <!--banner--> 
  
  <!--neirong-->
   <div class="bread_bg"><div class="bread"> <a href="/">首页</a> - <a href="#">快速检索</a></div></div>
  <div class="neirong">
  <div class="search_top"></div>
      <!--search-->
      <div class="search_bg">
    <div class="search">
          <input name="" type="text"  placeholder="快速检索" class="search_txt" v-model="keyword" @keyup.enter="search"/>
          <input name="" type="button"  class="search_but" @click="search"/>
        </div>
    <p>高频搜索内容：<a href="javascript:void(0)" @click="selData(item.name)" v-for="item in keyList" :key="item.id">{{item.name}}</a></p>
  </div>
      <!--search--> 
      <ul class="result_list">
      <li v-for="item in list"><a href="javascript:void(0)" @click="goDetail(item)" v-html="highlightKeyword(item.title, keyword)"></a><p>{{ item.catTitle }}</p></li>
      
      </ul>
	        <ul id="page">
	            <li><a href="javascript:void(0)" @click="goPage('home')">首页</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('last')">上一页</a></li>
	            <li v-for="index in indexs" @click="goPage(index)"><a :class="pageNum==index?'pagesel':''" href="javascript:void(0)">{{index}}</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('next')">下一页</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('end')">尾页</a></li>
	            <li class="total">共{{totalPage}}页</li>
	        </ul>
	      </div>
	    </div>
	         <Footer></Footer> 
	   
	  </div>
	  
    
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{getArticleFastSearch,getKeywordList} from '@/api/reqFetch.js'
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			keyList:[],
			keyword:'',
			selid:'0',
			list:[],
			pageNum: 1,
			indexs: [],
			totalPage: 0,
			showPhone:false,
		}
  	},

  	mounted() {
        this.keyword=this.$route.query.keyword
	  this.getData()
      this.getKeywordList()
  	},

  	methods: {
        highlightKeyword(title, keyword) {
            if (!keyword) return title; // 无关键词时返回原标题
            const reg = new RegExp(keyword, 'gi'); // 全局不区分大小写匹配
            return title.replace(reg, match => `<strong>${match}</strong>`);
        },
		changePhone(val){
			this.showPhone=val
		},
		goNext(url){
			this.$router.push({
				path:url,
			})
		},
        selData(name){
            this.keyword=name
            this.search()
        },
        
		getKeywordList(){
			getKeywordList().then(res => {
				this.keyList = res.data;
			});
		},
		search(){
			this.pageNum=1;
			this.getData()
		},

		checkIndex() {
		    var left = 1;
		    var right = this.totalPage;
		    var ar = [];
		    if (this.totalPage >= 3) {
		        if (this.pageNum > 1 && this.pageNum < this.totalPage - 2) {
		            left = this.pageNum - 1
		            right = this.pageNum + 1
		        } else {
		            if (this.pageNum <= 1) {
		                left = 1
		                right = 3
		            } else {
		                right = this.totalPage
		                left = this.totalPage - 2
		            }
		        }
		    }
		    while (left <= right) {
		        ar.push(left)
		        left++
		    }
		    this.indexs = ar
		
		},
		goPage(type) {
		    if (type == 'home') {
		        this.pageNum = 1
		    } else if (type == 'end') {
		        this.pageNum = Number(this.totalPage)
		
		    } else if (type == 'last') {
		        if (this.pageNum > 1) {
		            this.pageNum = this.pageNum - 1
		        }
		    } else if (type == 'next') {
		        if (this.pageNum < (this.totalPage)) {
		            this.pageNum = this.pageNum + 1
		        }
		    } else {
		        this.pageNum = type
		    }
		    this.getData()
		},
		getData(){
			let par={
				pageNumber: this.pageNum,
				keyword:this.keyword,
				pageSize: 5,
				
			}
			getArticleFastSearch(par).then(res => {
			  this.list = res.data.list;
			  this.totalPage = Math.ceil(res.data.totalRow / 5)
			  this.checkIndex();
			});
		},
		goDetail(item){
            if(item.type==1){
                this.$router.push({
				path:'/context',
				query:{id:item.id}
			  })
            }else if(item.type==2){
                this.$router.push({
				path:'/caseDetail',
				query:{id:item.id}
			  })
            }
			else if(item.type==3){
			    this.$router.push({
				path:'/solutionList',
				query:{id:item.id,name:item.title}
			  })
			}
			else if(item.type==4){
			    this.$router.push({
				path:'/solutionDetail',
				query:{id:item.id}
			  })
			}
		}
     
  	}
  }
</script>

<style scoped>
	.banner{
		background-image: url('../../assets/images/banner_08.png');
	}


</style>
